import {Component, Input, OnInit} from '@angular/core';
import {ModelClasses} from "../../../../core/model/modelClasses";
import {Events} from "../../../providers/events";

@Component({
    selector: 'list-filter',
    templateUrl: './list-filter.component.html',
    styleUrls: ['./list-filter.component.scss'],
})
export class ListFilterComponent implements OnInit {

    @Input()
    public modelName: string;

    public model: any;

    @Input()
    public prefix: string;

    @Input()
    public filters: object;

    @Input()
    public fieldKey: string;

    @Input()
    public fields: Array<string>;

    public models: Array<any> = [];

    public fieldData: object;
    public fieldsData: object;

    @Input()
    public activeFilters = {'checked':{}, 'checkedData': {}, 'checkedArr':[], 'count':0};

    constructor(public modelClasses: ModelClasses, public events: Events,) {
    }

    ngOnInit() {
        let cls = this.modelClasses.getClass(this.modelName);
        this.model = new cls({});
        //
        // for(let key in this.fields)
        // {
        //   this.fieldsData[key] = this.model.dataFields[this.fieldKey]
        // }

        this.fieldData = this.model.dataFields[this.fieldKey];

        this.initFilters()
    }

    initFilters()
    {
        let key = this.fieldKey;
        if (this.fieldData['multipleFilterKey'])
            key = this.fieldData['multipleFilterKey'];

        if(!this.filters[key]) return;

        let key_filters =  this.filters[key].split(',');
        for(let k in key_filters){
            this.activeFilters['checked'][key_filters[k]] = true;
        }
    }

    setFilter(model) {
        // if(this.activeFilters['checked'][model.data.id])
        //   this.activeFilters['checked'][model.data.id] = -1;
        // else
        //   this.activeFilter = model.data.id;

        this.activeFilters['checked'][model.data.id] = !this.activeFilters['checked'][model.data.id];
        this.activeFilters['checkedData'][model.data.id] = model;

        this.updateFilters()
    }

    updateFilters() {
        let key = this.fieldKey;
        if (this.fieldData['multipleFilterKey'])
            key = this.fieldData['multipleFilterKey'];

        let arr = []
        for (let k in this.activeFilters['checked']) {
            if (this.activeFilters['checked'][k]) {
                arr.push(k);
            }
        }

        this.activeFilters['count'] = arr.length;
        this.activeFilters['checkedArr'] = arr;

        this.filters[key] = arr.join(',');
        this.filters['offset'] = 0;
        ////console.logthis.filters)
        this.events.publish(this.prefix + '_updateFilter', this.filters);
    }

}
